import {
  Button,
  Icon,
  Popover,
  RadioButton,
  RadioButtonGroup,
  Stack,
  Text,
  Toggle,
  useTheme,
} from '@sixfold/common-ui';
import * as React from 'react';

type Brand = 'transporeon' | 'trimble';

export const ThemeSwitcher = () => {
  const { currentTheme, setTheme } = useTheme();
  const [isVisible, setIsVisible] = React.useState(false);

  const isDark = currentTheme?.includes('dark') ?? false;
  const brand: Brand = currentTheme?.includes('trimble') ? 'trimble' : 'transporeon';

  const handleBrandChange = React.useCallback(
    ({ value }: { value: Brand }) => {
      setTheme(`${value}-${isDark ? 'dark' : 'light'}`);
    },
    [setTheme, isDark],
  );

  const handleModeChange = React.useCallback(
    ({ checked }: { checked: boolean }) => {
      setTheme(`${brand}-${checked ? 'dark' : 'light'}`);
    },
    [setTheme, brand],
  );

  const hidePopover = React.useCallback(() => setIsVisible(false), []);
  const showPopover = React.useCallback(() => setIsVisible(true), []);

  return (
    <Popover
      placement="bottom-end"
      fallbackPlacements={['bottom', 'left']}
      isVisible={isVisible}
      onHide={hidePopover}
      onShow={showPopover}
      showsArrow={false}
      padding="medium"
      content={
        <Stack direction="column" gap="medium">
          <Stack direction="column" gap="small">
            <Text size="small" prominence="subtle">
              Brand
            </Text>
            <RadioButtonGroup label="Brand" labelPosition="hidden" value={brand} onChange={handleBrandChange}>
              <RadioButton value="transporeon" label="Transporeon" />
              <RadioButton value="trimble" label="Trimble" />
            </RadioButtonGroup>
          </Stack>
          <Toggle label="Dark mode" checked={isDark} onChange={handleModeChange} />
        </Stack>
      }>
      <Button kind="ghost" size="small" aria-label="Switch theme">
        <Icon name={isDark ? 'dark' : 'light'} size={16} />
      </Button>
    </Popover>
  );
};
